( function ( _s ) {
	_s( document ).ready( () => {
		/** Scrollbar width */
		const scrollbarWidth = () => {
			window.setRootProperty(
				'--scrollbar-width',
				parseInt( window.innerWidth - document.documentElement.clientWidth ) + 'px'
			);
		};

		scrollbarWidth();

		_s( window ).on(
			'resize',
			window.debounce( () => {
				scrollbarWidth();
			}, 200 )
		);
	} );
} )( window._s );
